/* disc-vitals-fix.js — Move Vitals payment icons under mobile ATC button */
(function() {
  var done = false;
  function fix() {
    if (done) return;
    var txt = document.querySelector('.disc-hero__text');
    if (!txt) return;
    var imgs = txt.getElementsByTagName('img');
    var vNode = null;
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].src && imgs[i].src.indexOf('opusecom') !== -1) {
        vNode = imgs[i];
        break;
      }
    }
    if (!vNode) return;
    /* Walk up to the direct child of .disc-hero__text */
    var box = vNode;
    while (box && box.parentElement !== txt) {
      box = box.parentElement;
    }
    if (!box) return;
    /* Clone to mobile CTA */
    var mob = document.querySelector('.disc-hero__cta--mobile');
    if (mob) {
      mob.appendChild(box.cloneNode(true));
    }
    /* Hide original on mobile via class */
    box.classList.add('disc-vitals-desktop-only');
    done = true;
    console.log('[disc-vitals-fix] Badges cloned to mobile CTA');
  }
  /* Watch for Vitals injection */
  var target = document.querySelector('.disc-hero__text');
  if (target) {
    new MutationObserver(function() { fix(); }).observe(target, { childList: true, subtree: true });
  }
  /* Fallback polling */
  setTimeout(fix, 1500);
  setTimeout(fix, 3000);
  setTimeout(fix, 6000);
})();
